import { useEffect, useState, useMemo } from "react";
import { Typography, CircularProgress, Grid } from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";

//import general components
import BASE_URL from "../../../../constants/baseUrls";
import BaseTable from "../../../common/base-table/base-table";

const BaggageRulesModal = ({ fareSourceCode, uniqueId, baggageInfo, setBaggageInfo, flightItem }) => {
    //general variables
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getBaggageRules = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`${BASE_URL}/api/v2/reserve/foreign/flight/baggages/`, {
                params: { fare_source_code: fareSourceCode, unique_id: uniqueId },
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            if (response.data && response.data.data.baggage_info) {
                setBaggageInfo(response.data.data.baggage_info);
            } else {
                setError(t("retry"));
            }
        } catch (error) {
            setError(`${t("retry")}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!baggageInfo && flightItem) {
            if (flightItem.tag === "ch118") {
                const formattedBaggageInfo = [
                    {
                        flight_no: flightItem.flight_number,
                        departure: flightItem.departure,
                        arrival: flightItem.destination,
                        baggage: `${flightItem?.baggage?.Quantity}${flightItem?.baggage?.Unit}`,
                    },
                ];
                setBaggageInfo(formattedBaggageInfo);
            } else {
                if ((fareSourceCode || uniqueId) && !baggageInfo?.length) {
                    getBaggageRules();
                }
            }
        }
    }, [flightItem, fareSourceCode, uniqueId]);

    //table's columns
    const columns = useMemo(() => [
        {
            accessorKey: "flightNumber",
            header: `${t("flightNumber")}`,
            enableSorting: false,
            size: 50,
        },
        {
            accessorKey: "departure",
            header: `${t("departure")}`,
            enableSorting: false,
            size: 50,
        },
        {
            accessorKey: "destination",
            header: `${t("destination")}`,
            enableSorting: false,
            size: 50,
        },
        {
            accessorKey: "baggage",
            header: `${t("baggage")}`,
            enableSorting: false,
            size: 50,
        },
    ]);

    //table's rows
    const [rows, setRows] = useState([]);
    useEffect(() => {
        if (!!baggageInfo) {
            setRows(
                baggageInfo?.map(info => ({
                    flightNumber: info.flight_no,
                    departure: info.departure,
                    destination: info.arrival,
                    baggage: info.baggage,
                })),
            );
        }
    }, [baggageInfo]);

    return (
        <Grid container item xs={12} justifyContent="center">
            {loading ? (
                <Grid container item xs={12} justifyContent="center" alignItems="center">
                    <CircularProgress color="inherit" size={24} />
                </Grid>
            ) : error ? (
                <Typography color="error" text onClick={getBaggageRules} sx={{ cursor: "pointer", textDecoration: "underline" }}>
                    {error}
                </Typography>
            ) : baggageInfo && baggageInfo.length > 0 ? (
                <BaseTable columns={columns} rows={rows} details={false} action={false} rowBackground="var(--white-gray-color)" />
            ) : (
                <Typography>{t("Toast Messages.Information Unavailable")}</Typography>
            )}
        </Grid>
    );
};

export default BaggageRulesModal;
